import { Box, MenuItem } from '@mui/material';
import React from 'react';
import { permissionObj } from './../../Helpers/permission';
import DataDetailsModal from './Modal/DataDetailsModal';
import ButtonAction from '../../components/buttons/ButtonAction';
import HeadTittle from '../../components/HeadTittle';
import CustomTable from '../../components/table/CustomTable';
import HardDeleteTableApp from './Functionality/HardDeleteTableApp';
import DeleteModal from '..//Modals/DeleteModal';
import { CustomSelectAndChildren } from '../../components/CustomSelectAndChildren';
import { RestoreIcon, TrashOutlineIcon } from '../../components/buttons/IconButtons';
import HardDeleteApp from "./Functionality/HardDeleteApp";
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const HardDelete = () => {
    const {
        t,
        DEV,
        permission,
        selectedEmployee,
        selectedModel,
        deleteEmployeesShow,
        restoreShow,
        model,
        handleOpenModal,
        handleChange,
        setDeleteEmployeesShow,
        setRestoreShow,
        setModel,
        handleCloseModal,
        transformedList,
        dataDetail,
        openModal,
        restoreSelectedItems,
        deleteSelectedEmployees,
        selectItemsForDelete,
        setSelectItemsForDelete,
        isAllChecked,
        modified,
        setModified,
        searchElement,
        setIsAllChecked
    } = HardDeleteApp();

    const { tableId, searchId, thead, tbody, handleCheckboxChange, handleDeleteAll, getActionsButtons, pagination,
        deletePermission} =
        HardDeleteTableApp({
            handleOpenModal,
            selectedModel,
            model,
            selectedList:selectItemsForDelete,
            setSelectedList: setSelectItemsForDelete,
            modified,
            setModified,
            searchElement,
            setIsAllChecked
        });

    return (
        <>
            <Box>
                <HeadTittle name={'delete_and_restore'}>
                    {(DEV || permission?.includes(permissionObj?.WEB_HARD_DELETE_RECOVER)) && (
                        <ButtonAction
                            id='btn_hd_restore'
                            name='restore'
                            className='btn-icon-add'
                            disabled={!selectItemsForDelete.length > 0}
                            Icon={RestoreIcon}
                            onClick={() => {
                                handleCloseModal();
                                setRestoreShow(true);
                            }}
                        />
                    )}

                    {(DEV || permission?.includes(permissionObj?.WEB_HARD_DELETE_DELETE)) && (
                        <ButtonAction
                            id='btn_hd_delete'
                            name='delete'
                            className='btn-icon-delete'
                            onClick={() => setDeleteEmployeesShow(true)}
                            disabled={!selectItemsForDelete.length > 0}
                            Icon={TrashOutlineIcon}
                        />
                    )}
                </HeadTittle>
                <Box className='col-6 m-0 p-0'>
                    <CustomSelectAndChildren
                        id='slt_hd_model'
                        name='model'
                        trans='model'
                        value={model}
                        onChange={(e) => {
                            const selectedModel = e.target.value;
                            setModel(selectedModel);
                            handleChange(selectedModel);
                        }}
                        required={true}
                        showNoSelectionOption={true}
                    >
                        {transformedList?.map((item, index) => (
                            <MenuItem key={index} value={item}>
                                {t(item).toUpperCase()}
                            </MenuItem>
                        ))}
                    </CustomSelectAndChildren>
                </Box>
                <CustomTable
                    tableId={tableId}
                    searchId={searchId}
                    checkbox={deletePermission}
                    checkboxTitle={'de_/_select_all'}
                    thead={thead}
                    tbody={tbody}
                    getActionsButtons={getActionsButtons}
                    handleCheckboxChange={handleCheckboxChange}
                    selectedList={selectItemsForDelete}
                    isAllChecked={isAllChecked}
                    onChangeCheckbox={handleDeleteAll}
                />
            </Box>
            {pagination()}

            <DataDetailsModal
                openModal={openModal}
                handleCloseModal={handleCloseModal}
                employeeData={selectedEmployee}
                dataDetail={dataDetail}
                selectedModel={selectedModel}
            />
            <DeleteModal
                show={deleteEmployeesShow}
                onHide={() => setDeleteEmployeesShow(false)}
                data={selectItemsForDelete}
                onClickFn={() => deleteSelectedEmployees(selectItemsForDelete, selectedModel)}
                title_modal={t('delete_records')}
                description={t('are_you_sure_you_want_to_delete')}
                element_modal={t('records')}
            />
            <DeleteModal
                show={restoreShow}
                onHide={() => setRestoreShow(false)}
                onClickFn={() => {
                    restoreSelectedItems(selectItemsForDelete, selectedModel);
                }}
                data={selectItemsForDelete}
                title_modal={t('restore_records')}
                description={t('are_you_sure_you_want_to_restore')}
                element_modal={t('records')}
            />
        </>
    );
};

export default HardDelete;
